import React from 'react';
import PropTypes from 'prop-types';

import ProjectCard from 'components/project/project_card';
import CsvImporter from 'components/csv_importer/csv_importer';
import PageHeader from 'components/project/page_header';

export default class LeadImporter extends React.Component {
  static propTypes = {
    crmEnabled: PropTypes.bool.isRequired,
    fieldFormat: PropTypes.object.isRequired,
    importPath: PropTypes.string.isRequired,
    onFinishImport: PropTypes.func.isRequired
  }

  render() {
    const title = (
      <React.Fragment>
        <span className="text-muted">Leads &gt; </span>
        Import Leads
      </React.Fragment>
    );

    return (
      <React.Fragment>
        <PageHeader title={title} />
        {this.renderImporter()}
      </React.Fragment>
    );
  }

  renderImporter() {
    let fileUploadHelpText = 'Leads uploaded will only be added to this Project';

    if (this.props.crmEnabled) {
      fileUploadHelpText += ', and contacts will not automatically be created in a database from leads import.';
    } else {
      fileUploadHelpText += '.';
    }

    return (
      <ProjectCard className="p-5">
        <CsvImporter
          fieldFormat={this.props.fieldFormat}
          fileUploadHelpText={fileUploadHelpText}
          importPath={this.props.importPath}
          objectType="lead"
          onFinish={this.props.onFinishImport}
        />
      </ProjectCard>
    );
  }
}
